<div
  class="chat-container"
  *ngIf="chatWindowOpened"
  [ngStyle]="{
    'font-family': configs?.fonts?.default_font,
    'font-size': configs?.fonts?.default_font_size_px + 'px' || '16px',
  }"
>
  <mat-card class="collapsible-chat">
    <card-header
      class="chat-header"
      [ngStyle]="{ backgroundColor: configs?.colors?.bot_title_background }"
    >
      <div class="chat-header__header-user-image">
        <img
          mat-card-avatar
          [src]="configs?.bot_title_profile_url"
          class="chat-icon"
        />
      </div>
      <div
        class="chat-header__title-text"
        [ngStyle]="{
          'font-family': configs?.fonts?.bot_title_font,
          'font-size': configs?.fonts?.bot_title_font_size_px + 'px' || '20px',
          'font-weight': configs?.fonts?.bot_title_font_weight,
          color: configs?.colors?.bot_title_text,
        }"
      >
        {{ configs?.bot_title }}
      </div>
      <div class="chat-header__close-icon">
        <button
          mat-icon-button
          [matMenuTriggerFor]="menu"
          aria-label=""
          class="hamburger-menu"
          style="cursor: pointer !important; position: relative; z-index: 1000"
        >
          <mat-icon [ngStyle]="{ color: configs?.colors?.bot_title_text }"
            >menu</mat-icon
          >
        </button>
        <mat-menu #menu="matMenu" class="settings-menu">
          <button
            class="restart-hover"
            mat-menu-item
            (click)="toggleChat()"
            [ngStyle]="{
              '--hover-color':
                configs?.colors?.chat_menu_hover ||
                configs?.colors?.send_button_background ||
                '#256EFF',
            }"
          >
            <span
              [ngStyle]="{
                'font-family': configs?.fonts?.chat_menu_font,
                'font-size':
                  configs?.fonts?.chat_menu_font_size_px + 'px' || '16px',
              }"
              >Minimise Chat</span
            >
          </button>
          <!-- <button
            class="restart-hover"
            mat-menu-item
            (click)="openChatLinkDialog()"
            [ngStyle]="{
              'font-family': configs?.fonts?.chat_menu_font,
              'font-size':
                configs?.fonts?.chat_menu_font_size_px + 'px' || '16px',
                '--hover-color': configs?.colors?.chat_menu_hover || configs?.colors?.send_button_background || '#256EFF'
            }"
          >
            Request Link
          </button> -->
          <button mat-menu-item (click)="openRestartDialog()">
            <span
              [ngStyle]="{
                'font-family': configs?.fonts?.chat_menu_font,
                'font-size':
                  configs?.fonts?.chat_menu_font_size_px + 'px' || '16px',
              }"
              >Restart Alex</span
            >
          </button>
        </mat-menu>
      </div>

      <app-restart-popup
        *ngIf="showRestartDialog"
        [message]="restartInfo.message"
        [showCancel]="restartInfo.showCancel"
        (onRestart)="restartChat()"
        (onClose)="cancelRestartChat()"
      >
      </app-restart-popup>

      <!-- <app-chatlink-popup
        *ngIf="showChatLinkDialog"
        [chatLink]="chatLink"
        (onClose)="closeChatLinkDialog()"
      >
      </app-chatlink-popup> -->
    </card-header>
    <mat-card-content
      class="chat-content"
      #chatContent
      [ngStyle]="{
        'font-family': configs?.fonts?.default_font,
        'font-size': configs?.fonts?.default_font_size_px + 'px' || '16px',
        background: configs?.colors?.bot_background,
      }"
    >
      @for (message of conversation; track $index; let i = $index) {
        @if (
          !(message.content.type == "Typing" && i != conversation.length - 1)
        ) {
          <app-message-response
            [lastMessage]="i == conversation.length - 1"
            [message]="message"
            [canSendMessage]="canSendMessage"
            (action)="sendResponse($event)"
          ></app-message-response>
        }
      }
      <div *ngFor="let file of selectedFiles">
        <mat-card class="selected-file">
          <mat-card-content>
            <mat-icon>insert_drive_file</mat-icon>
            <span>{{ file.name }} ({{ file.size | number }} bytes)</span>
          </mat-card-content>
        </mat-card>
      </div>
    </mat-card-content>
    <mat-card-footer
      class="example-card-footer"
      *ngIf="chatInputVisible"
      [ngStyle]="{ background: configs?.colors?.bot_background }"
    >
      <mat-card-actions class="chat-actions">
        <div
          *ngIf="!fileUploadRequired"
          class="chat-input-area"
          [ngStyle]="{
            color: configs?.colors?.bot_title_text,
            border: '1px solid ' + configs?.colors?.border,
          }"
        >
          <input
            #chatInput
            class="chat-input"
            type="text"
            placeholder="Type message..."
            [disabled]="!canSendMessage"
            [(ngModel)]="message"
            (keydown.enter)="sendMessage($event)"
            [ngStyle]="{
              color: configs?.colors?.user_message_input_text,
              'font-family': configs?.fonts?.default_font,
              'font-size':
                configs?.fonts?.default_font_size_px + 'px' || '16px',
            }"
          />
          <button
            class="send-button"
            aria-label="Send"
            [disabled]="!canSendMessage"
            (click)="sendMessage($event)"
            [ngStyle]="{
              'background-color':
                configs?.colors?.send_button_background ??
                configs?.colors?.bot_title_background,
              border: '1px solid ' + configs?.colors?.border,
            }"
          >
            <mat-progress-spinner
              *ngIf="!canSendMessage"
              diameter="20"
              mode="indeterminate"
              [ngStyle]="{ color: configs?.colors?.send_button_icon }"
            ></mat-progress-spinner>
            <mat-icon
              *ngIf="canSendMessage"
              aria-hidden="false"
              class="send-icon"
              fontIcon="send"
              [ngStyle]="{ color: configs?.colors?.send_button_icon }"
            ></mat-icon>
          </button>
        </div>
        <app-file-upload
          class="file-upload-wrapper"
          *ngIf="fileUploadRequired"
          [configs]="configs"
          [uploadedFiles]="uploadedFiles"
          (filesSelected)="onFilesSelected($event)"
          (cancelUpload)="onCancelUpload()"
        ></app-file-upload>
      </mat-card-actions>
    </mat-card-footer>
  </mat-card>
</div>

<div *ngIf="botEnabled">
  <div
    class="chat-toggle-btn"
    (click)="toggleChat()"
    [ngStyle]="{
      backgroundColor: configs?.colors?.start_button_background,
    }"
  >
    <span
      [ngStyle]="{
        color: configs?.colors?.start_button_text,
        'font-family': configs?.fonts?.bot_title_font,
      }"
    >
      {{ configs?.start_button_text }}
    </span>
    <svg
      width="30px"
      height="20px"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      class="si-glyph si-glyph-bubble-message-talk"
      [ngStyle]="{ fill: configs?.colors?.start_button_icon }"
    >
      <defs></defs>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g
          transform="translate(0.000000, 1.000000)"
          [attr.fill]="configs?.colors?.start_button_icon"
        >
          <path
            d="M5.939,0 C2.666,0 0.00899999996,1.987 0.00899999996,4.438 C0.00899999996,6.674 2.224,8.52 5.101,8.825 L3.88,11.26 L8.129,8.56 C10.318,7.906 12,6.309 12,4.438 C12,1.988 9.213,0 5.939,0 Z"
            class="si-glyph-fill"
          ></path>
          <path
            d="M15.947,8.89 C15.947,7.766 14.885,6.602 13.658,6.022 C13.314,7.972 11.734,9.767 9.241,10.469 L8.054,11.111 C8.508,11.451 9.064,11.722 9.688,11.899 L13.326,13.87 L12.023,12.094 C14.24,11.869 15.947,10.523 15.947,8.89 L15.947,8.89 Z"
            class="si-glyph-fill"
          ></path>
        </g>
      </g>
    </svg>
  </div>
</div>
